// src/pages/InvoicePrint.jsx
import React from "react";

const safePrice = (price) => Number(price) || 0;

export default function InvoicePrint({ data }) {
  const {
    address = {},
    cartItems = [],
    total = 0,
    deliveryFee = 0,
    grandTotal = 0,
    discountAmount = 0,
    paymentMode = "Cash on Delivery",
  } = data;

  const orderDate = new Date().toLocaleDateString("en-IN");
  const orderTime = new Date().toLocaleTimeString("en-IN", { hour: '2-digit', minute: '2-digit' });
  const orderId = "3T" + Date.now().toString().slice(-6);

  return (
    <div style={{ padding: "40px", background: "white", fontFamily: "'Roboto', sans-serif" }}>
      {/* HEADER */}
      <div style={{ textAlign: "center", marginBottom: "40px" }}>
        <h1 style={{ fontSize: "56px", fontWeight: "900", color: "#111827", margin: "0" }}>3THREDS</h1>
        <p style={{ fontSize: "22px", color: "#6b7280", margin: "8px 0" }}>Premium Streetwear • Made in India</p>
        <div style={{ width: "140px", height: "140px", background: "#f3f4f6", border: "8px dashed #9ca3af", borderRadius: "50%", margin: "20px auto", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <span style={{ fontSize: "70px", fontWeight: "900", color: "#374151" }}>3T</span>
        </div>
        <div style={{ color: "#4b5563", fontSize: "15px", lineHeight: "1.6" }}>
          <p style={{ fontWeight: "bold" }}>Gokul Nagar, Hosur, Tamil Nadu - 635109</p>
          <p>GST: 33AAJCS2870M1ZJ</p>
          <p>support@3threds.in | +91 98765 43210 | www.3threds.in</p>
        </div>
      </div>

      <hr style={{ border: "3px solid #1f2937", margin: "40px 0" }} />

      {/* ORDER & ADDRESS */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "50px", marginBottom: "40px" }}>
        <div style={{ background: "#f9fafb", padding: "25px", borderRadius: "16px", border: "2px solid #e5e7eb" }}>
          <h3 style={{ fontWeight: "bold", color: "#1f2937", fontSize: "20px", marginBottom: "15px" }}>Order Details</h3>
          <p><strong>Order ID:</strong> #{orderId}</p>
          <p><strong>Date:</strong> {orderDate}</p>
          <p><strong>Time:</strong> {orderTime}</p>
          <p><strong>Payment:</strong> <span style={{ fontWeight: "bold", color: paymentMode.includes("Razorpay") ? "#16a34a" : "#ea580c" }}>{paymentMode}</span></p>
        </div>
        <div style={{ background: "#f9fafb", padding: "25px", borderRadius: "16px", border: "2px solid #e5e7eb" }}>
          <h3 style={{ fontWeight: "bold", color: "#1f2937", fontSize: "20px", marginBottom: "15px" }}>Delivery Address</h3>
          <p style={{ fontWeight: "bold", fontSize: "18px" }}>{address.name}</p>
          <p>{address.house}, {address.road}</p>
          <p>{address.city}, {address.state} - {address.pincode}</p>
          <p><strong>Phone:</strong> {address.phone}</p>
        </div>
      </div>

      {/* PRODUCTS TABLE WITH ID + NAME */}
      <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "40px" }}>
        <thead>
          <tr style={{ background: "#1f2937", color: "white" }}>
            <th style={{ padding: "18px", textAlign: "left" }}>ID</th>
            <th style={{ padding: "18px", textAlign: "left" }}>Product Name</th>
            <th style={{ padding: "18px", textAlign: "center" }}>Qty</th>
            <th style={{ padding: "18px", textAlign: "right" }}>Price</th>
            <th style={{ padding: "18px", textAlign: "right" }}>Total</th>
          </tr>
        </thead>
        <tbody>
          {cartItems.map((item, i) => (
            <tr key={i} style={{ borderBottom: "2px solid #e5e7eb" }}>
              <td style={{ padding: "18px", fontFamily: "monospace", fontWeight: "bold", color: "#6b7280" }}>
                #{item.id || "N/A"}
              </td>
              <td style={{ padding: "18px", fontWeight: "600", fontSize: "16px" }}>
                {item.name}
                {item.size && <span style={{ color: "#6b7280", fontSize: "13px", marginLeft: "8px" }}>• {item.size}</span>}
                {item.color && <span style={{ color: "#6b7280", fontSize: "13px", marginLeft: "8px" }}>• {item.color}</span>}
              </td>
              <td style={{ padding: "18px", textAlign: "center", fontWeight: "bold", fontSize: "18px" }}>{item.quantity}</td>
              <td style={{ padding: "18px", textAlign: "right", fontWeight: "600" }}>₹{safePrice(item.price).toFixed(2)}</td>
              <td style={{ padding: "18px", textAlign: "right", fontWeight: "bold", color: "#1f2937", fontSize: "18px" }}>
                ₹{(safePrice(item.price) * item.quantity).toFixed(2)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* PRICE SUMMARY */}
      <div style={{ maxWidth: "450px", marginLeft: "auto", background: "#f9fafb", padding: "30px", borderRadius: "20px", border: "3px solid #1f2937" }}>
        <div style={{ fontSize: "20px", fontWeight: "600" }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "15px" }}>
            <span>Subtotal</span>
            <span>₹{safePrice(total).toFixed(2)}</span>
          </div>
          {discountAmount > 0 && (
            <div style={{ display: "flex", justifyContent: "space-between", color: "#16a34a", fontWeight: "bold", fontSize: "24px" }}>
              <span>Discount Applied</span>
              <span>-₹{safePrice(discountAmount).toFixed(2)}</span>
            </div>
          )}
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: "15px" }}>
            <span>Delivery</span>
            <span style={{ fontWeight: "bold" }}>{deliveryFee === 0 ? "FREE" : `₹${deliveryFee}`}</span>
          </div>
          <hr style={{ border: "2px solid #1f2937", margin: "20px 0" }} />
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: "32px", fontWeight: "900", color: "#1f2937" }}>
            <span>TOTAL</span>
            <span>₹{safePrice(grandTotal).toFixed(2)}</span>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <div style={{ textAlign: "center", marginTop: "60px", paddingTop: "40px", borderTop: "5px solid #1f2937" }}>
        <h2 style={{ fontSize: "38px", fontWeight: "900", color: "#1f2937" }}>THANK YOU FOR CHOOSING 3THREDS!</h2>
        {paymentMode === "Cash on Delivery" ? (
          <div style={{ background: "#fed7aa", color: "#c2410c", padding: "25px 50px", borderRadius: "50px", display: "inline-block", marginTop: "25px", fontSize: "24px", fontWeight: "bold" }}>
            Keep ₹{safePrice(grandTotal).toFixed(2)} Ready for Delivery Boy
          </div>
        ) : (
          <div style={{ background: "#bbf7d0", color: "#16a34a", padding: "25px 50px", borderRadius: "50px", display: "inline-block", marginTop: "25px", fontSize: "24px", fontWeight: "bold" }}>
            Payment Received Successfully!
          </div>
        )}
        <p style={{ marginTop: "30px", color: "#4b5563", fontSize: "16px" }}>
          support@3threds.in | +91 98765 43210 | Follow @3threds.official
        </p>
      </div>
    </div>
  );
}